import { App as DesktopApp } from '@desktop/App';
import { createBrowserAppPlatform } from '@desktop/platform/browser';
import type { BrowserProjectFileGateway } from '@desktop/platform/browser/file-api';
import { createStoreBrowserProjectController } from '@desktop/platform/browser/project-controller';
import { useProjectStore } from '@desktop/store/project-store';
import { useLayoutEffect, useMemo, type ReactElement } from 'react';

interface LocalProjectAppProps {
  readonly onCloud: () => void;
  readonly files?: BrowserProjectFileGateway;
}

export function LocalProjectApp({ onCloud, files }: LocalProjectAppProps): ReactElement {
  const platform = useMemo(() => createBrowserAppPlatform({
    controller: createStoreBrowserProjectController(),
    ...(files === undefined ? {} : { files }),
  }), [files]);

  useLayoutEffect(() => {
    // Local mode is deliberately isolated from the last cloud document held by
    // the shared editor store. Importing a file remains available via 開啟.
    const store = useProjectStore.getState();
    store.setHostReadOnly(false);
    store.newProject();
  }, []);

  const leaveLocalMode = (): void => {
    if (
      useProjectStore.getState().file.isDirty &&
      !window.confirm('本機專案有尚未匯出的變更，確定要回到雲端專案嗎？')
    ) return;
    onCloud();
  };

  return (
    <main className="local-project-page">
      <header className="local-project-header">
        <div>
          <p className="eyebrow">BigInt Project Local</p>
          <h1>本機瀏覽器模式</h1>
          <p>不需登入；資料只在目前頁面記憶體中，請用「儲存」匯出 .bproj。</p>
        </div>
        <button type="button" className="secondary" onClick={leaveLocalMode}>前往雲端專案</button>
      </header>
      <div className="desktop-editor-shell local-editor-shell">
        <DesktopApp platform={platform} readOnly={false} allowProjectReplacement />
      </div>
    </main>
  );
}
